import D4DView from '../Views/D4DView.vue'
import StartProject from "../Pages/StartProject.vue";
import BeforeYouContinue from "../Pages/BeforeYouContinue"
import DeepCustomerEmpathy3 from "../Pages/DeepCustomerEmpathy3";
import DeepCustomerEmpathy4 from "../Pages/DeepCustomerEmpathy4";
import DeepCustomerEmpathy5 from "../Pages/DeepCustomerEmpathy5";
import DeepCustomerEmpathy6 from "../Pages/DeepCustomerEmpathy6";
import GoBroadToGoNarrow7 from "../Pages/GoBroadToGoNarrow7";
import GoBroadToGoNarrow8 from "../Pages/GoBroadToGoNarrow8";
import GoBroadToGoNarrow9 from "../Pages/GoBroadToGoNarrow9";
import GoBroadToGoNarrow10 from "../Pages/GoBroadToGoNarrow10";
import GoBroadToGoNarrow11 from "../Pages/GoBroadToGoNarrow11";
import GoBroadToGoNarrow12 from "../Pages/GoBroadToGoNarrow12";
import RapidExperimentsWithCustomers13 from "../Pages/RapidExperimentsWithCustomers13";
import RapidExperimentsWithCustomers14 from "../Pages/RapidExperimentsWithCustomers14";
import RapidExperimentsWithCustomers15 from "../Pages/RapidExperimentsWithCustomers15";
import RapidExperimentsWithCustomers16 from "../Pages/RapidExperimentsWithCustomers16";
import RapidExperimentsWithCustomers17 from "../Pages/RapidExperimentsWithCustomers17";
import RapidExperimentsWithCustomers18 from "../Pages/RapidExperimentsWithCustomers18";
import RapidExperimentsWithCustomers19 from "../Pages/RapidExperimentsWithCustomers19";
import Finish20 from "../Pages/Finish20";
import DeepCustomerEmpathy1 from "../Pages/DeepCustomerEmpathy1";

const routes = [
    {
        path: '/d4d',
        component: D4DView,
        children: [
            {
                path: '/start_project',
                name: 'start_project',
                component: StartProject,
                meta: {authRequired: true, showNavigation: false, showNavigationInfo: false, hideSideNavigation: true},
                props: {newProject: true}
            },
            {
                path: '/before_you_continue/:index',
                name: 'before_you_continue',
                component: BeforeYouContinue,
                meta: {authRequired: true, showNavigation: false, showNavigationInfo: false, hideSideNavigation: true}
            },
            {
                path: '/edit_project/:index',
                name: 'edit_project',
                component: StartProject,
                meta: {authRequired: true, showNavigation: false, showNavigationInfo: false, hideSideNavigation: true},
                props: {newProject: false}
            },
            {
                path: '/deep_customer_empathy_2/:index',
                name: 'deep_customer_empathy_2',
                component: DeepCustomerEmpathy1,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    isCoverPage: true,
                    pageNumber: "2 of 20"
                }
            },
            {
                path: '/deep_customer_empathy_3/:index',
                name: 'deep_customer_empathy_3',
                component: DeepCustomerEmpathy3,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Deep Customer Empathy",
                    pageNumber: "3 of 20"
                }
            },
            {
                path: '/deep_customer_empathy_4/:index',
                name: 'deep_customer_empathy_4',
                component: DeepCustomerEmpathy4,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Deep Customer Empathy",
                    pageNumber: "4 of 20"
                }
            },
            {
                path: '/deep_customer_empathy_5/:index',
                name: 'deep_customer_empathy_5',
                component: DeepCustomerEmpathy5,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Deep Customer Empathy",
                    pageNumber: "5 of 20"
                }
            },
            {
                path: '/deep_customer_empathy_6/:index',
                name: 'deep_customer_empathy_6',
                component: DeepCustomerEmpathy6,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Deep Customer Empathy",
                    pageNumber: "6 of 20"
                }
            },
            {
                path: '/go_broad_to_go_narrow_7/:index',
                name: 'go_broad_to_go_narrow_7',
                component: GoBroadToGoNarrow7,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    isCoverPage: true,
                    pageNumber: "7 of 20"
                }
            },
            {
                path: '/go_broad_to_go_narrow_8/:index',
                name: 'go_broad_to_go_narrow_8',
                component: GoBroadToGoNarrow8,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Go Broad To Go Narrow",
                    pageNumber: "8 of 20"
                }
            },
            {
                path: '/go_broad_to_go_narrow_9/:index',
                name: 'go_broad_to_go_narrow_9',
                component: GoBroadToGoNarrow9,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Go Broad To Go Narrow",
                    pageNumber: "9 of 20"
                }
            },
            {
                path: '/go_broad_to_go_narrow_10/:index',
                name: 'go_broad_to_go_narrow_10',
                component: GoBroadToGoNarrow10,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Go Broad To Go Narrow",
                    pageNumber: "10 of 20"
                }
            },
            {
                path: '/go_broad_to_go_narrow_11/:index',
                name: 'go_broad_to_go_narrow_11',
                component: GoBroadToGoNarrow11,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Go Broad To Go Narrow",
                    pageNumber: "11 of 20"
                }
            },
            {
                path: '/go_broad_to_go_narrow_12/:index',
                name: 'go_broad_to_go_narrow_12',
                component: GoBroadToGoNarrow12,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Go Broad To Go Narrow",
                    pageNumber: "12 of 20"
                }
            },
            {
                path: '/rapid_experiments_with_customers_13/:index',
                name: 'rapid_experiments_with_customers_13',
                component: RapidExperimentsWithCustomers13,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    isCoverPage: true,
                    pageNumber: "13 of 20"
                }
            },
            {
                path: '/rapid_experiments_with_customers_14/:index',
                name: 'rapid_experiments_with_customers_14',
                component: RapidExperimentsWithCustomers14,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Rapid experiments with customers ",
                    pageNumber: "14 of 20"
                }
            },
            {
                path: '/rapid_experiments_with_customers_15/:index',
                name: 'rapid_experiments_with_customers_15',
                component: RapidExperimentsWithCustomers15,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Rapid experiments with customers ",
                    pageNumber: "15 of 20"
                }
            },
            {
                path: '/rapid_experiments_with_customers_16/:index',
                name: 'rapid_experiments_with_customers_16',
                component: RapidExperimentsWithCustomers16,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Rapid experiments with customers",
                    pageNumber: "16 of 20"
                }
            },
            {
                path: '/rapid_experiments_with_customers_17/:index',
                name: 'rapid_experiments_with_customers_17',
                component: RapidExperimentsWithCustomers17,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Rapid experiments with customers",
                    pageNumber: "17 of 20"
                }
            },
            {
                path: '/rapid_experiments_with_customers_18/:index',
                name: 'rapid_experiments_with_customers_18',
                component: RapidExperimentsWithCustomers18,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Rapid experiments with customers",
                    pageNumber: "18 of 20"
                }
            },
            {
                path: '/rapid_experiments_with_customers_19/:index',
                name: 'rapid_experiments_with_customers_19',
                component: RapidExperimentsWithCustomers19,
                meta: {
                    authRequired: true,
                    showNavigation: true,
                    showNavigationInfo: true,
                    title: "Rapid experiments with customers",
                    pageNumber: "19 of 20"
                }
            },
            {
                path: '/finish_20/:index',
                name: 'finish_20',
                component: Finish20,
                meta: {authRequired: true, showNavigation: false, showNavigationInfo: false}
            }
        ]
    }
]

export default routes
